// @flow
import * as React from 'react';
import Box from 'sail/Box';
import Button from 'sail/Button';
import {defineMessages, useIntl} from 'react-intl';
import {api} from 'sail/Icon/Assets';
import {useStripeClui} from './helpers/react/provider';

import './style.scss';

export const StripeClui = (props: {}) => {
  const {
    state: {openState},
    toggleOpen,
  } = useStripeClui();

  const messages = defineMessages({
    showTerminal: {
      id: 'docsApp.showTerminal',
      description: 'Label for button to show CLUI terminal.',
      defaultMessage: 'Try it online',
    },
    hideTerminal: {
      id: 'docsApp.HideTerminal',
      description: 'Label for button to hide CLUI terminal.',
      defaultMessage: 'Close the CLI Terminal',
    },
  });

  const intl = useIntl();
  const showLabel = intl.formatMessage(messages.showTerminal);
  const hideLabel = intl.formatMessage(messages.hideTerminal);

  return (
    <Box margin={{top: 24}}>
      <Button
        icon={api}
        color="blue"
        size="jumbo"
        onClick={toggleOpen}
        label={openState !== 'closed' ? hideLabel : showLabel}
      />
    </Box>
  );
};
